export default {
  en: {
    unanswered: 'Unanswered',
    notApplicable: 'Not applicable',
    invalid: 'Invalid',
    unknown: 'Unknown',
    selectPlaceholder: 'Select an option',
    notRequired: 'Not required',
    policyRequirement: '{n} allowed option | {n} allowed options',
    anyOf: 'Any of: {labels}',
    requireHeading: 'Allowed options',
    policyPlaceholder: 'Search for options to allow',
    lastModified: 'Last modified {0}',
    outOfScope: 'Out of scope',
    errors: {
      emptySingleSelect: 'Requires at least one allowed option to be selected.',
    },
  },
};
